module.exports = "\n<div class=\"flex\">\n\t\n\t<div class=\"block\">\n\t\t<div class=\"client\">\n\t\t\t<h2>Client</h2>\n\t\t\t<p>\n\t\t\t\tExporter tous les clients de l'application dans un fichier Excel.\n\t\t\t</p>\n\t\t\t\n\t\t\t<button (click)=\"export()\">\n\t\t\t\tExporter\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/export/export.component.html
// module id = 747
// module chunks = 1